<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #dcdde0',
    }"
  >
    <div class="question-type">完型填空</div>
    <div class="title-view">
      <div style="color: #4c4a56">
        <div style="color: #4c4a56">
          <div v-html="richNodes" class="case-problem-html"></div>
        </div>
      </div>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div
      v-for="(data, idx) in list"
      :key="idx"
      style="
        border: 0.5px solid #dcdde0;
        border-radius: 4px;
        padding: 0 20px 20px 20px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
      "
    >
      <div class="number">{{ idx + 1 }}</div>
      <div style="flex: 1">
        <div v-for="(item, index) in data.title" :key="index">
          <div v-if="showState === 10 || showState === 7">
            <div
              v-if="item.color === '1'"
              class="choose-css"
              style="
                border: 1px solid rgba(74, 115, 247, 0.5);
                background: rgba(74, 115, 247, 0.1);
              "
            >
              <span
                style="
                  white-space: normal;
                  word-break: break-all;
                  color: rgba(58, 96, 255, 1);
                "
              >
                {{ item.id + "、" + item.text }}
              </span>
              <div style="display: flex; align-items: center">
                <div class="true-answer" style="color: #00c755">
                  {{ item.isCorrect ? "正确答案" : "" }}
                </div>
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg"
                  style="width: 30px; height: 30px"
                />
              </div>
            </div>
            <div
              v-if="item.color === '2'"
              class="choose-css"
              style="
                border: 1px solid rgba(247, 59, 66, 0.5);
                background: rgba(247, 59, 66, 0.1);
              "
            >
              <span
                style="
                  white-space: normal;
                  word-break: break-all;
                  color: rgba(247, 59, 66, 1);
                "
              >
                {{ item.id + "、" + item.text }}
              </span>
              <div style="display: flex; align-items: center">
                <div class="true-answer" style="color: #00c755">
                  {{ item.isCorrect ? "正确答案" : "" }}
                </div>
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1747885842739.svg"
                  style="width: 30px; height: 30px"
                />
              </div>
            </div>
            <div
              v-if="item.color === '3'"
              class="choose-css"
              style="
                border: 1px solid rgba(0, 199, 85, 0.5);
                background: rgba(0, 199, 85, 0.1);
              "
            >
              <span
                style="
                  white-space: normal;
                  word-break: break-all;
                  color: rgba(58, 96, 255, 1);
                "
              >
                {{ item.id + "、" + item.text }}
              </span>
              <div style="display: flex; align-items: center">
                <div class="true-answer" style="color: #00c755">
                  {{ item.isCorrect ? "正确答案" : "" }}
                </div>
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1747885970303.svg"
                  style="width: 30px; height: 30px"
                />
              </div>
            </div>
            <div
              v-if="item.color === '4'"
              class="choose-css"
              style="
                border: 1px solid rgba(255, 172, 58, 0.5);
                background: rgba(255, 172, 58, 0.1);
              "
            >
              <span
                style="
                  white-space: normal;
                  word-break: break-all;
                  color: rgba(58, 96, 255, 1);
                "
              >
                {{ item.id + "、" + item.text }}
              </span>
              <div style="display: flex; align-items: center">
                <div class="true-answer" style="color: #00c755">
                  {{ item.isCorrect ? "正确答案" : "" }}
                </div>
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1747885864346.svg"
                  style="width: 30px; height: 30px"
                />
              </div>
            </div>
            <div
              v-if="item.color === '0'"
              class="choose-css"
              style="
                border: 1px solid rgba(237, 237, 237, 1);
                background: rgba(247, 247, 247, 1);
              "
            >
              <span
                style="
                  white-space: normal;
                  word-break: break-all;
                  color: rgba(43, 47, 54, 1);
                "
              >
                {{ item.id + "、" + item.text }}
              </span>
              <div style="display: flex; align-items: center">
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1747892286609.svg"
                  style="width: 30px; height: 30px"
                />
              </div>
            </div>
          </div>
          <div
            v-else
            class="choose-css choose-css-new"
            :style="{
              border: item.isChoose
                ? `1px solid rgba(${themeColor.r},${themeColor.g},${themeColor.b},0.5)`
                : '1px solid rgba(237,237,237,0.5)',
              background: item.isChoose
                ? `rgba(${themeColor.r},${themeColor.g},${themeColor.b},0.1)`
                : 'rgba(247,247,247,1)',
            }"
            @click="handleChoose({ item: item, idx: idx, index: index })"
          >
            <div class="choose-css-text">
              <span
                style="white-space: normal; word-break: break-all"
                :style="{
                  color: item.isChoose
                    ? `rgba(${themeColor.r},${themeColor.g},${themeColor.b},1)`
                    : 'rgba(43,47,54,1)',
                  fontWeight: item.isChoose ? 'bold' : 'normal',
                }"
              >
                {{
                  (isEmpty(item.id) ? optionLetters[index] : item.id) +
                  "、" +
                  item.text
                }}
              </span>
              <div style="display: flex; align-items: center">
                <div
                  v-if="dataObj.status === 2 || dataObj.status === 3"
                  class="true-answer"
                >
                  {{ item.isCorrect ? "正确答案" : "" }}
                </div>
                <img
                  v-if="dataObj.status === 4"
                  :src="
                    item.isChoose
                      ? 'https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg'
                      : 'https://ossfastmake.mustke.com/qrCode/tupian/1747892286609.svg'
                  "
                  style="width: 30px; height: 30px"
                />
              </div>
            </div>

            <div class="question-images">
              <div
                class="question-images-box"
                @click.stop="showBigImage(imgItem, item)"
                v-for="(imgItem, imgIndex) in item.img_path"
                :key="imgIndex"
                style="margin-top: 20px; position: relative"
              >
                <img :src="imgItem" class="thumbnail-image" />
                <div class="fangda-box">查看图片</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
      <div class="popup-content" @click.stop>
        <img
          src="@/assets/images/guanbi.png"
          class="popup-guanbi"
          @click="fangdaClose"
        />
        <div class="popup-scroll">
          <div>{{ fangdaTitle }}</div>
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </div>
    </div>
    <div v-if="showState === 10 || showState === 7">
      <div
        v-if="dataObj.ifRight"
        style="display: flex; align-items: center; margin-top: 20px"
      >
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335507420.svg"
          style="width: 32px; height: 32px"
        />
        <span class="correct-text">回答正确 +{{ dataObj.score }}分</span>
      </div>
      <div v-else style="display: flex; align-items: center; margin-top: 20px">
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335577224.svg"
          style="width: 32px; height: 32px"
        />
        <span class="error-text" style="font-size: 30px; font-weight: 500"
          >答错了 {{ dataObj.score > 0 ? `+${dataObj.score}分` : "" }}</span
        >
      </div>
      <div v-if="!dataObj.ifRight" style="margin-top: 20px">
        <span
          style="
            font-size: 30px;
            font-weight: 500;
            text-align: left;
            color: #00c755;
          "
          >正确答案</span
        >
        <div
          style="
            width: 100%;
            padding: 25px;
            box-sizing: border-box;
            background: #f7f7f7;
            border: 1px solid #ededed;
            border-radius: 6px;
            margin-top: 15px;
          "
        >
          {{ dataObj.chooseAnswer }}
        </div>
      </div>
      <div class="explanation-section" style="margin-top: 20px">
        <span class="section-title" style="font-size: 30px; font-weight: 500"
          >答案解析</span
        >
        <div class="textarea-view">{{ dataObj.analysis || "暂无内容" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewClozeTest",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      images: [],
      index: 0,
      themeColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      showState: 0,
      list: [],
      optionLetters: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
	  hasAnswer: false,
    };
  },
  computed: {
    richNodes() {
      if (!this.dataObj.caseProblem) return "";

      let count = 0;
      let prefix =
        this.dataObj.isMust === 1
          ? `<span style="color:#F73B42;">*</span>${this.index + 1}、`
          : `${this.index + 1}、`;

      const body = this.dataObj.caseProblem.replace(/____/g, () => {
        const html = `
          <span style="border-bottom: 1px solid #494949; padding-bottom: 3px; position: relative; top: -3px;">
            <b style="font-weight: normal; font-size: 10px; color: #494949; text-align: center; display: inline-flex; align-items: center; justify-content: center; border: 1px solid #494949; width: 15px; height: 15px; border-radius: 25px; margin-left: 10px; margin-right: 8px;">
              ${count + 1}
            </b>
          </span>
        `;
        count++;
        return html;
      });

		let scoreHtml = "";
		
		if (!this.hasAnswer) {
		  scoreHtml = `<span style="position:relative;top:-1px;padding:0 8px;line-height:24px;background:rgba(58,96,255,0.09);border:1px solid rgba(58,96,255,0.4);border-radius:4px;font-size:13px;font-weight:500;text-align:center;color:#3a60ff;display:inline-block;margin-left:5px">${this.dataObj.questionScore}分</span>`;
		}
		
		return prefix + body + scoreHtml;
    },
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          this.list = JSON.parse(
            newValue.data.chooseList || '{"list":[]}',
          ).list;
          this.showState = newValue.state;

          if (
            newValue.theme &&
            newValue.theme.themeColor
          ) {
            this.themeColor = {
              r: newValue.theme.themeColor.r,
              g: newValue.theme.themeColor.g,
              b: newValue.theme.themeColor.b,
            };
          }
        }
		let answerData = newValue.answer;
		if (typeof answerData === "string") {
		  try {
		    answerData = JSON.parse(answerData);
		  } catch (e) {
		    answerData = {};
		  }
		}
		this.hasAnswer =
		  answerData &&
		  answerData.answer &&
		  answerData.answer.length > 0;
		const answerArr = answerData.answer || [];
		this.list.forEach(group => {
		  group.title.forEach(item => {
		    item.isChoose = false;
		  });
		});
		answerArr.forEach(ans => {
		  const targetGroup = this.list.find(g => g.id === ans.id);
		  if (targetGroup) {
		    const targetItem = targetGroup.title.find(
		      t => t.id === ans.context
		    );
		    if (targetItem) {
		      targetItem.isChoose = true;
		    }
		  }
		});
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleChoose({ item, idx, index }) {
      if (this.dataObj.data.status === 4 || this.dataObj.data.status === 3) {
        for (let j = 0; j < this.list[idx].title.length; j++) {
          this.list[idx].title[j].isChoose = false;
        }
        this.list[idx].title[index].isChoose = true;

        const updatedData = {
          ...this.dataObj.data,
          chooseList: JSON.stringify({ list: this.list }),
        };

        const answerObj = {
          question_id: this.dataObj.data.id,
          type: this.dataObj.data.type,
          if_hide: this.dataObj.data.if_hide,
          answer: this.list.map((item) => {
            const chosenItem = item.title.find(
              (titleItem) => titleItem.isChoose === true,
            );
            return {
              id: item.id,
              context: chosenItem ? chosenItem.id : "",
            };
          }),
        };

        this.$emit(
          "update",
          JSON.stringify({
            data: updatedData,
            index: this.index,
            answer: answerObj,
          }),
        );
      }
    },
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text;
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
    isEmpty(value) {
      return value === null || value === undefined || value === "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./exam-preview-common.scss";

.title-view > div {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.title-view > div > div {
  display: flex;
  align-items: flex-end;
}

.case-problem-html {
  flex: 1;
}

.number {
  width: 18px;
  height: 18px;
  color: #949eaf;
  border: 0.5px solid #949eaf;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  margin-right: 10px;
  flex: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewClozeTest.vue